<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="5.462" height="14.337" viewBox="0 0 5.462 14.337">
    <g>
      <rect width="1.745" height="12.721" transform="translate(1.75)" fill="#606a6c" />
      <path d="M2.731,0,5.462,2.731H0Z" transform="translate(5.462 14.337) rotate(180)" fill="#606a6c" />
    </g>
  </svg>
</template>
